<template>
  <button
    :class="{ 'default': true, orange, disabled, wide, danger, bigPadding }"
    :disabled="disabled"
    @click="$emit('click')"
  >
    <slot />
  </button>
</template>

<script>
export default {
  name: "DsButton",
  props: {
    disabled: {
      type: Boolean,
      default: false
    },
    orange: {
      type: Boolean,
      default: false
    },
    wide: {
      type: Boolean,
      default: false
    },
    danger: {
      type: Boolean,
      default: false
    },
    bigPadding: {
      type: Boolean,
      default: false
    }
  }
};
</script>

<style lang="scss" scoped>
@import "../../scss/_variables.scss";
@import "../../scss/_mixins.scss";

$vertical-padding: 0.9em;
$side-padding: 1.68em;

.default {
  border: 0px;
  padding: $vertical-padding $side-padding;
  outline: none;
  position: relative;
  color: #fff;
  background-color: $light-green-color;
  border-radius: 25px;
  font-weight: 500;
  transition: $animation-speed linear;
  white-space: nowrap;
  @include fluid-font($font-small-size, true);
  user-select: none;
  &:hover {
    transition: $animation-speed linear;
    background-color: $light-green-color-hover;
  }
  &:active {
    background-color: #3baf8c;
  }
  &:focus,
  &:active {
    outline: none;
    box-shadow: none;
  }
  a {
    color: #fff;
  }
}
.disabled {
  background-color: #f1f1f1;
  &:hover {
    background-color: #f1f1f1;
  }
}
.danger {
  background-color: $dark-red-color;
  &:hover {
    background-color: $red-error-color;
  }
}
.orange {
  background-color: $orange-color;
  &:hover {
    background-color: $orange-light-color;
  }
}
.bigPadding {
  padding: 1.1em 2em !important;
}

.wide {
  padding: $vertical-padding $side-padding + 0.7;
}
</style>



// WEBPACK FOOTER //
// ../panel-theme/src/js/widgets/ds-button.vue